import React, { useState } from 'react';
import { trackFeatureTryIt, trackFeatureFormOpened } from './utils/analytics';
import './FeaturesDisplay.css';

const FEATURES = [
  {
    id: 'interior',
    title: 'Interior Design',
    description: 'Transform your interior spaces with AI-powered design',
    beforeImage: 'https://iili.io/fMA6Zvt.png',
    afterImage: 'https://iili.io/fMA6Zvt.png'
  },
  {
    id: 'exterior',
    title: 'Exterior Design',
    description: 'Redesign outdoor spaces and exteriors',
    beforeImage: 'https://iili.io/fMAi4gp.png',
    afterImage: 'https://iili.io/fMAi4gp.png'
  },
  {
    id: 'style',
    title: 'Reference Style',
    description: 'Show AI what you like and let it style your space',
    beforeImage: 'https://iili.io/fMA6Zvt.png',
    afterImage: 'https://iili.io/fMA6Zvt.png'
  },
  {
    id: 'paint',
    title: 'Paint',
    description: 'Visualize paint colors and finishes',
    beforeImage: 'https://iili.io/fMAbQcJ.png',
    afterImage: 'https://iili.io/fMAbQcJ.png'
  },
  {
    id: 'floor',
    title: 'Floor Restyle',
    description: 'Redesign and restyle your floors',
    beforeImage: 'https://iili.io/fMROkZB.png',
    afterImage: 'https://iili.io/fMROkZB.png'
  },
  {
    id: 'replace',
    title: 'Replace Object',
    description: 'Replace objects in your space',
    beforeImage: 'https://iili.io/fMRWlIt.png',
    afterImage: 'https://iili.io/fMRWlIt.png'
  }
];

function FeaturesDisplay({ user, onFeatureClick, onShowSignIn }) {
  const [showBeforeAfter, setShowBeforeAfter] = useState({
    interior: true,
    exterior: true,
    style: true,
    paint: true,
    floor: true,
    replace: true
  });
  
  // Map 'references' to 'style' for backward compatibility with hover states
  const getFeatureId = (id) => id === 'references' ? 'style' : id;

  const toggleBeforeAfter = (featureId) => {
    setShowBeforeAfter(prev => ({
      ...prev,
      [featureId]: !prev[featureId]
    }));
  };

  const handleTryItClick = (featureId) => {
    console.log('handleTryItClick called with:', featureId, 'user:', user);
    
    const feature = FEATURES.find(f => f.id === featureId);
    const featureTitle = feature?.title || featureId;
    
    // Track the try it click
    trackFeatureTryIt(featureId, featureTitle, !!user, 'features_display');
    
    if (!user) {
      // User not signed in, show sign-in modal
      console.log('No user, showing sign-in modal');
      if (onShowSignIn) {
        onShowSignIn();
      }
    } else {
      // User is signed in, trigger feature modal
      console.log('User signed in, calling onFeatureClick');
      
      // Track that feature form is being opened
      trackFeatureFormOpened(featureId, featureTitle, 'try_it_button');
      
      if (onFeatureClick) {
        onFeatureClick(featureId);
      } else {
        console.error('onFeatureClick is not defined!');
      }
    }
  };

  return (
    <div className="features-display">
      <div className="features-header">
        <h2>Our Features</h2>
        <p>Explore all the powerful design tools at your fingertips</p>
      </div>
      
      <div className="features-grid">
        {FEATURES.map(feature => (
          <div key={feature.id} className="feature-card">
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
            
            <div className="feature-preview">
              <div className={`before-after-container ${feature.id === 'floor' || feature.id === 'replace' ? 'no-border' : ''}`}>
                <img 
                  src={feature.beforeImage} 
                  alt="Before" 
                  className={`before-after-image ${showBeforeAfter[feature.id] ? 'show' : 'hide'}`}
                />
                <img 
                  src={feature.afterImage} 
                  alt="After" 
                  className={`before-after-image ${!showBeforeAfter[feature.id] ? 'show' : 'hide'}`}
                />
              </div>
            </div>
            
            <button 
              className="try-it-btn"
              onClick={() => handleTryItClick(feature.id)}
            >
              Try it
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FeaturesDisplay;

